import P from "../../pages";
import { generateProfileElementObject, changeState } from "../../utilities";
import React from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { defaultMessages } from "../../../../libs/i18n/default";
import FormHeader from "./FormHeader";
import Redirector from "./Redirector";
import Alert from "./Alert";
import ButtonGroup from "./ButtonGroup";
import ProfileElementField from "./ProfileElementField";
import FormControl from "react-bootstrap/lib/FormControl";
import ControlLabel from "react-bootstrap/lib/ControlLabel";
import CustomFormGroup from "./CustomFormGroup";
import { pageValid, executeValidations } from "../../validator";
import MedicalIcon from "react-icons/lib/md/local-hospital";

class HealthAndMedical extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      medicalConditionsOrMedication: generateProfileElementObject(
        this.props.profileElements,
        this.props.activeProfileElements,
        "",
        "lifestyle",
        "medical_conditions_or_medication",
      ),
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount() {
    executeValidations(this);
  }

  changeState = async (id, val) => {
    changeState(this, id, val);
  };

  back(e) {
    this.props.onGoBack();
  }

  submit(e) {
    let payload = {
      lifestyle: {
        medical_conditions_or_medication: this.state.medicalConditionsOrMedication.val,
      },
    };
    this.props.onHostProfileSubmit(payload);
  }

  render() {
    const thisPage = P.HEALTH_AND_MEDICAL_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className="profile">
        <Redirector this_page={thisPage} page={page} />
        <form onSubmit={this.submit}>
          <FormHeader title={content.pages.health_and_medical.title} icon={<MedicalIcon />} />

          <ProfileElementField
            childComponent={
              <CustomFormGroup valid={this.state.medicalConditionsOrMedication.valid}>
                <ControlLabel>
                  {formatMessage(defaultMessages.clientHostPagesHealthAndMedicalLabelsMedicalConditionsOrMedication)}
                </ControlLabel>
                <FormControl
                  type="text"
                  id={"medicalConditionsOrMedication"}
                  componentClass="textarea"
                  style={{ height: "150px", width: "100%" }}
                  placeholder=""
                  defaultValue={this.state.medicalConditionsOrMedication.val}
                  onChange={(e) => this.changeState(e.target.id, e.target.value)}
                />
              </CustomFormGroup>
            }
            elementName="medical_conditions_or_medication"
          />

          <Alert alert={content.pages.health_and_medical.info} />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl}
          />
        </form>
      </div>
    );
  }
}

HealthAndMedical.propTypes = {
  onHostProfileSubmit: PropTypes.func,
  onSkipSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  page: PropTypes.string,
  intl: PropTypes.object,
  content: PropTypes.object,
};

export default injectIntl(HealthAndMedical);
